import Axios, {AxiosHeaders} from "axios";

type AxiosRequestLike = {
    data?: unknown;
    headers?: unknown;
};

export const normalizeAxiosRequestConfig = <T extends AxiosRequestLike>(
    config: T,
): T => {
    const headers = AxiosHeaders.from((config.headers ?? {}) as any);

    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
        headers.delete("Content-Type");
    } else if (!headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
    }

    return {
        ...config,
        headers,
    } as T;
};

let requestInterceptorId: number | undefined;

export const configureAxios = (baseURL: string) => {
    Axios.defaults.baseURL = baseURL;
    delete Axios.defaults.headers.common["Content-Type"];
    Axios.defaults.headers.common["Accept"] = "application/json";
    Axios.defaults.withCredentials = true;

    if (requestInterceptorId !== undefined) {
        Axios.interceptors.request.eject(requestInterceptorId);
    }

    requestInterceptorId = Axios.interceptors.request.use((config) =>
        normalizeAxiosRequestConfig(config),
    );
};
